export default "__VITE_ASSET__DtJHZ5lg__"